import axios from 'axios';

export async function requestCancellation(contractId: string) {
  return axios.post(`/api/user/contracts/${contractId}/request-cancellation`);
}
